var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLabs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 16.5,
    cy: 1.5,
    fill: "#2196f3",
    r: 1.5,
    "data-original": "#00bcd4",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 16.5,
    cy: 1.5,
    fill: "#2196f3",
    r: 1.5,
    "data-original": "#00a4b9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m17.3 14.66-.82.46c-.45.25-.97.38-1.48.38s-1.03-.13-1.47-.37l-.79-.45c-.44-.24-1.04-.24-1.49.01l-.77.43c-.9.5-2.06.5-2.95.01l-1.7-.96-2.577 2.576c-.808.796-1.253 1.863-1.253 3.004 0 2.343 1.907 4.25 4.25 4.25 1.141 0 2.208-.445 3-1.25z",
    fill: "#2196f3",
    "data-original": "#00bcd4",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#eceff1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 20c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1z",
    fill: "#deeffe",
    "data-original": "#eceff1",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 18c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1z",
    fill: "#deeffe",
    "data-original": "#eceff1",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.78 6.22-8.45 8.45 1.7.96c.89.49 2.05.49 2.95-.01l.77-.43c.45-.25 1.05-.25 1.49-.01l.79.45c.44.24.96.37 1.47.37s1.03-.13 1.48-.38l.82-.46 2.98-2.94z",
    fill: "#deeffe",
    "data-original": "#eceff1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m12.71 11.71c-.408.387-1.012.387-1.42 0l-1.5-1.5 1.42-1.42 1.5 1.5c.39.39.39 1.03 0 1.42z",
    fill: "#bdd3e2",
    "data-original": "#607d8b",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m19.293 13.707-7-7c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l7 7c.391.391.391 1.023 0 1.414s-1.023.391-1.414 0z",
    fill: "#bdd3e2",
    "data-original": "#607d8b",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m5.83 14.17-2.577 2.576c-.808.796-1.253 1.863-1.253 3.004 0 1.033.371 1.981.986 2.718l2.114-2.033c-.064-.132-.1-.279-.1-.435 0-.552.448-1 1-1 .17 0 .329.042.469.117l3.807-3.662-.296.165c-.452.251-.97.376-1.486.376-.511 0-1.021-.123-1.463-.366l-1.7-.96z",
    fill: "#2196f3",
    "data-original": "#00a4b9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m6 19c-.552 0-1 .448-1 1 0 .156.036.303.099.435l1.37-1.318c-.14-.075-.299-.117-.469-.117z",
    fill: "#deeffe",
    "data-original": "#cdd0d2",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m12.793 7.207-1.583 1.583 1.5 1.5c.39.39.39 1.03 0 1.42-.204.194-.457.29-.71.29s-.506-.097-.71-.29l-1.5-1.5-3.96 3.96-.5.5 1.7.96c.443.244.952.366 1.463.366.516 0 1.034-.125 1.486-.376l.296-.166 5.486-5.278z",
    fill: "#deeffe",
    "data-original": "#cdd0d2",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m11.21 8.79-1.42 1.42 1.5 1.5c.204.194.457.29.71.29s.506-.097.71-.29c.39-.39.39-1.03 0-1.42z",
    fill: "#bdd3e2",
    "data-original": "#546d79",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m13 5c-.256 0-.512.098-.707.293-.391.391-.391 1.023 0 1.414l.5.5 2.97 2.97 1.441-1.387-3.497-3.497c-.195-.195-.451-.293-.707-.293z",
    fill: "#bdd3e2",
    "data-original": "#546d79",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m20 8c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z",
    fill: "#2196f3",
    "data-original": "#00bcd4",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m20 4c-1.103 0-2 .897-2 2 0 .465.159.893.426 1.233l.025.017 2.861-2.75.003-.006c-.352-.307-.812-.494-1.315-.494z",
    fill: "#2196f3",
    "data-original": "#00a4b9",
    style: {},
    className: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabs);
export default __webpack_public_path__ + "static/media/labs.7afe073af0fc136e3c600cce6ada7148.svg";
export { ForwardRef as ReactComponent };